'use strict';

const { h } = require('phy');
const { Translate, WithI18n } = require('@grpn/preact-l10n');
const DateTime = require('@grpn/preact-l10n/datetime');
const { connect } = require('preact-redux');

const RedemptionProvider = require('../../redemption/views/redemption-provider');
const CouponsList = require('../../coupons/views/coupons-list-filter');

const MerchantLogoImage = require('../../shared/views/merchants/merchant-logo-image');

function renderCouponTotal({ isTouch, couponsForList }) {
  return h(`.merchant-ppc-total${isTouch ? '-mobile' : ''}`, [
    h('span.icon-tag.merchant-ppc-total-icon'),
    h(
      Translate,
      {
        0: couponsForList.length,
        attrs: { class: 'merchant-ppc-total-text' },
      },
      'modules.widget.Statistics.CodesAvailable'
    ),
  ]);
}

function renderOutlink({
  isTouch,
  merchantRedirect,
  merchantSlug,
  merchantWebsiteName,
}) {
  return h(
    `a.merchant-ppc-outlink${isTouch ? '-mobile' : ''}`,
    {
      href: `${merchantRedirect}?referralSource=ppc`,
      target: '_blank',
      rel: 'noopener nofollow',
      'data-bhw': `store:${merchantSlug}`,
    },
    h(
      Translate,
      {
        attrs: { class: 'merchant-ppc-outlink-text' },
        0: merchantWebsiteName,
      },
      'modules.widget.ShopAtFormat'
    )
  );
}

function MerchantPPC({ payload, params, deps, isTouch }) {
  const {
    seoMetaData: { h1Override },
    merchantDetails,
    couponsForList,
    directRedemption,
  } = payload;
  const { routes, showUberOffer } = deps;

  const merchantRedirect = routes.redirect.merchant.replace(
    '{merchantId}',
    merchantDetails.merchantId
  );

  const totalText = h(
    '.merchant-ppc-section',
    renderCouponTotal({ isTouch, couponsForList })
  );

  const outlinkText = renderOutlink({
    isTouch,
    merchantRedirect,
    merchantSlug: params.merchantSlug,
    merchantWebsiteName: merchantDetails.merchantWebsiteName,
  });

  return h('article', [
    h(RedemptionProvider, { routes, directRedemption, referralSource: 'ppc' }),
    h('section.container.merchant-ppc', [
      h('.merchant-ppc-layout', [
        h('.merchant-ppc-sidebar', [
          h('.merchant-ppc-section.merchant-ppc-section-logo', [
            h(WithI18n, {}, i18n =>
              h(
                '.merchant-ppc-logo',
                MerchantLogoImage({
                  className: 'merchant-ppc-logo-image',
                  data: merchantDetails.merchantMedia,
                  size: ['w_220,h_220'],
                  alt: i18n.t('js.modules.shared.LogoAltTextFormat', {
                    0: merchantDetails.merchantName,
                  }),
                })
              )
            ),
            !isTouch ? [totalText, outlinkText] : null,
          ]),
        ]),
        h(
          '.merchant-ppc-meta',
          merchantDetails.description &&
            h(
              '.merchant-ppc-section.merchant-ppc-about',
              h(
                Translate,
                {
                  tag: 'h3',
                  attrs: { class: 'merchant-ppc-heading' },
                  0: merchantDetails.merchantName,
                },
                'modules.merchant.AboutMerchantHeadingFormat'
              ),
              h('span.merchant-ppc-text', merchantDetails.description)
            )
        ),
        h('.merchant-ppc-content', [
          h(
            'h1.merchant-ppc-title',
            h1Override ||
              h(
                Translate,
                {
                  tag: 'span',
                  attrs: { class: 'merchant-ppc-title-text' },
                  0: merchantDetails.merchantName,
                  1: h(DateTime, {
                    value: Date.now(),
                    format: 'MMMM YYYY',
                  }),
                },
                'modules.merchant.OffersPageHeadingFormat'
              )
          ),
          isTouch ? [totalText, outlinkText] : null,
          h(
            '.merchant-ppc-section',
            {
              'data-bhw': `MerchantCouponsList:${params.merchantSlug}`,
            },
            h(CouponsList, {
              routes,
              coupons: couponsForList,
              media: 'callout',
              referralSource: 'ppc',
              showUberOffer,
            })
          ),
        ]),
      ]),
    ]),
  ]);
}

const mapStateToProps = state => ({
  isTouch: state.isTouch,
});

module.exports = connect(mapStateToProps)(MerchantPPC);
